/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface CommentDto
 */
export interface CommentDto {
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    applicationFormId: string;
    /**
     * 
     * @type {string}
     * @memberof CommentDto
     */
    formElementId: string;
    /**
     * 
     * @type {Date}
     * @memberof CommentDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CommentDto
     */
    modifiedAt: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof CommentDto
     */
    createdBy: UserDto;
}

/**
 * Check if a given object implements the CommentDto interface.
 */
export function instanceOfCommentDto(value: object): value is CommentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('applicationFormId' in value) || value['applicationFormId'] === undefined) return false;
    if (!('formElementId' in value) || value['formElementId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('modifiedAt' in value) || value['modifiedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function CommentDtoFromJSON(json: any): CommentDto {
    return CommentDtoFromJSONTyped(json, false);
}

export function CommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'message': json['message'],
        'applicationFormId': json['applicationFormId'],
        'formElementId': json['formElementId'],
        'createdAt': (new Date(json['createdAt'])),
        'modifiedAt': (new Date(json['modifiedAt'])),
        'createdBy': UserDtoFromJSON(json['createdBy']),
    };
}

export function CommentDtoToJSON(json: any): CommentDto {
    return CommentDtoToJSONTyped(json, false);
}

export function CommentDtoToJSONTyped(value?: CommentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'message': value['message'],
        'applicationFormId': value['applicationFormId'],
        'formElementId': value['formElementId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'modifiedAt': ((value['modifiedAt']).toISOString()),
        'createdBy': UserDtoToJSON(value['createdBy']),
    };
}

